<admin-app-header></admin-app-header>

<div class="map-page">
    <!-- Controls Bar -->
    <div class="controls-bar">
        <div class="controls-left">
            <h1><i class="fa-solid fa-fire"></i> Heat Map</h1>
            <span class="count-badge">{{ pricedParkings.length | number }} published parkings</span>
            <span class="count-badge count-badge--muted" *ngIf="unpricedCount" title="Published with no monthly price of at least R100">
                {{ unpricedCount | number }} without a price
            </span>
        </div>
        <div class="legend" *ngIf="bands.length">
            <span class="legend-title">Median monthly price</span>
            <span class="legend-band" *ngFor="let band of bands">
                <span class="legend-dot" [style.background-color]="band.color"></span>
                R{{ band.from | number: '1.0-0' }}–R{{ band.to | number: '1.0-0' }}
            </span>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Loading parkings...</p>
    </div>

    <div class="map-body" *ngIf="!loading">
        <!-- Map -->
        <div class="map-container">
            <agm-map
                [latitude]="cameraLat"
                [longitude]="cameraLng"
                [zoom]="zoom"
                [scrollwheel]="true"
                gestureHandling="greedy"
                [streetViewControl]="false"
                [mapTypeControl]="true"
                [styles]="mapStyles"
                (centerChange)="onCenterChange($event)"
                (zoomChange)="onZoomChange($event)"
                style="height: 100%"
            >
                <agm-circle
                    *ngFor="let zone of zones; trackBy: trackZone"
                    [latitude]="zone.lat"
                    [longitude]="zone.lng"
                    [radius]="zone.radius"
                    [fillColor]="zone.color"
                    [fillOpacity]="0.55"
                    [strokeColor]="zone.color"
                    [strokeOpacity]="0.9"
                    [strokeWeight]="1"
                    (circleClick)="onZoneClick(zone)"
                ></agm-circle>

                <agm-info-window
                    *ngIf="selectedZone"
                    [latitude]="selectedZone.lat"
                    [longitude]="selectedZone.lng"
                    [isOpen]="!!selectedZone"
                    (infoWindowClose)="onInfoWindowClose()"
                >
                    <div class="info-window">
                        <div class="info-header">
                            <h3>{{ selectedZone.count }} parking{{ selectedZone.count !== 1 ? 's' : '' }}</h3>
                            <span class="price-badge" [style.background-color]="selectedZone.color">
                                R{{ selectedZone.median | number: '1.0-0' }} median
                            </span>
                        </div>
                        <div class="info-range" *ngIf="selectedZone.count > 1">
                            Range R{{ selectedZone.min | number: '1.0-0' }} – R{{ selectedZone.max | number: '1.0-0' }} / month
                        </div>
                        <div class="info-list">
                            <div class="info-list-row" *ngFor="let item of selectedZone.parkings">
                                <span class="legend-dot" [style.background-color]="colorFor(item.price)"></span>
                                <a [href]="'/parking/' + item.parking.$key" target="_blank" class="info-link">{{ item.parking.title || 'Untitled Parking' }}</a>
                                <span class="info-price">R{{ item.price | number: '1.0-0' }}</span>
                                <a
                                    *ngIf="getMerchantKey(item.parking)"
                                    [routerLink]="['/merchant', getMerchantKey(item.parking), 'parking', item.parking.$key]"
                                    class="info-edit"
                                    title="Edit parking"
                                >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </agm-info-window>
            </agm-map>
        </div>

        <!-- Ranking -->
        <aside class="ranking">
            <h2>Most expensive areas</h2>
            <p class="ranking-note">Median monthly price per suburb, at least 2 published listings. Click to zoom in.</p>
            <button class="ranking-row" *ngFor="let area of topAreas; let i = index" (click)="focusArea(area)">
                <span class="ranking-pos">{{ i + 1 }}</span>
                <span class="legend-dot" [style.background-color]="colorFor(area.median)"></span>
                <span class="ranking-name">{{ area.name }}</span>
                <span class="ranking-price">R{{ area.median | number: '1.0-0' }}</span>
                <span class="ranking-count">{{ area.count }}</span>
            </button>
            <p class="ranking-note" *ngIf="!topAreas.length">Not enough priced listings yet.</p>
        </aside>
    </div>
</div>
